import Switch from '@material-ui/core/Switch';
import { animated, useSpring } from '@react-spring/web';
import { ReactComponent as ArrowDown } from "assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowTop } from "assets/icons/ArrowTop.svg";
import InfoTooltip from 'components/InfoTooltip';
import { LabelField } from 'components/LabelField';
import SwitchTabs from "components/SwitchTabs";
import React, { useMemo, useState } from 'react';
import { ArrowButton, Input, InputWrapper, WrapperButtons, InputDays } from "./Theme";
import { datePeriods, dateTypes, disableRecurringList, limitTypes, recurringTypes, disableRecurringNamesList, days } from "./tabsContants";

const CreateTriggerTabs = ({ formik }) => {

  const handleInputChange = ({ event, minValue = 0, maxValue, name }) => {
    const value = event.target.value;
    if (value < minValue || value === minValue || !value || (maxValue && value > maxValue)) return;
    formik.setFieldValue(name, Number(value));
  };

  const incrementHandler = ({ name, maxValue }) => {
    const prevValue = formik.values?.[name];
    if (maxValue && prevValue + 1 > maxValue) return;
    formik.setFieldValue(name, Number(prevValue + 1));
  }
  const decrementHandler = ({ name, minValue }) => {
    const prevValue = formik.values?.[name];
    if (minValue && prevValue - 1 < minValue) return;
    formik.setFieldValue(name, Number(prevValue - 1));
  }

  console.log("formik", formik);
  const enableLimitTo = useMemo(() => formik.values?.eventType?.label === "Anniversary" || formik.values?.eventType?.label === "Birthday", [formik.values?.eventType?.label]);
  const disableRecurring = useMemo(() => disableRecurringNamesList?.includes(formik.values?.eventType?.label), [formik.values?.eventType?.label]);

  const collapseLimitStyles = useSpring({
    height: enableLimitTo ? 120 : 0,
    opacity: enableLimitTo ? 1 : 0,
    config: { duration: 200 },
  });

  const collapseRecurringStyles = useSpring({
    height: disableRecurring ? 0 : 90,
    opacity: disableRecurring ? 0 : 1,
    config: { duration: 200 },
  });

  const collapseWhenStyles = useSpring({
    height: formik.values?.isRecurring ? 0 : 140,
    opacity: formik.values?.isRecurring ? 0 : 1,
    config: { duration: 200 },
  });


  return (
    <>
      <animated.div style={collapseWhenStyles}>
        {(!formik.values?.isRecurring) && (
          <div className="trigger mt-5" style={{ minHeight: "147px" }}>
            <div className="d-flex align-items-center">
              <LabelField
                title={"When to get in contact?"}
                style={{
                  fontSize: "12px",
                }}
                mandatory={true}
              />
              <InfoTooltip text="This task is created a set number of days before or after the event date, or on the event date itself." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
            </div>
            <SwitchTabs
              options={dateTypes}
              value={formik.values?.timeType}
              onChange={(tab) => formik.setFieldValue("timeType", tab?.value)}
            />

            {formik.values?.timeType !== "on the day" && (
              <WrapperButtons>
                <InputWrapper>
                  <Input
                    type="number"
                    value={formik.values?.timeUnit}
                    onChange={(e) => {
                      handleInputChange({ event: e, name: "timeUnit", minValue: 1 });
                    }}
                    min="1"
                  />
                  <ArrowButton onClick={() => {
                    incrementHandler({ name: "timeUnit" });
                  }}>
                    <ArrowTop />
                  </ArrowButton>
                  <ArrowButton onClick={() => {
                    decrementHandler({ name: "timeUnit", minValue: 1 });
                  }}>
                    <ArrowDown />
                  </ArrowButton>
                </InputWrapper>
                <SwitchTabs
                  options={datePeriods}
                  value={formik.values?.timePeriod}
                  onChange={(tab) => formik.setFieldValue("timePeriod", tab?.value)}
                  className="flex-shrink-1"
                />
              </WrapperButtons>
            )}
          </div>
        )}
      </animated.div>
      <animated.div style={collapseRecurringStyles}>
        <div className="trigger mt-5" >
          {!disableRecurring && formik.values?.eventType && (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <LabelField
                  title={"Is it recurring?"}
                  style={{
                    fontSize: "12px",
                  }}
                  mandatory={formik.values?.isRecurring}
                />
                <InfoTooltip text="When on, this task repeats weekly or monthly instead of being created only once for this event." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
              </div>
              <div className="d-flex align-items-center">
                <Switch
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  checked={formik.values?.isRecurring}
                  onChange={(event) => {
                    const { checked } = event.target;
                    formik.setFieldValue("isRecurring", checked);
                  }}
                />
              </div>
            </div>
          )}
          {formik.values?.isRecurring && formik.values?.recurringType === 1 && (
            <WrapperButtons>
              <SwitchTabs
                options={recurringTypes}
                value={formik.values?.recurringType}
                onChange={(tab) => formik.setFieldValue("recurringType", tab?.value)}
                className="flex-shrink-1"
              />
              <InputWrapper>
                <InputDays
                  type="text"
                  value={days[formik.values?.dayID - 1].name}

                  onChange={(e) => {
                    handleInputChange({ event: e, name: "dayID", minValue: 1 });
                  }}
                  min="1"
                  max="7"
                />
                <ArrowButton onClick={() => {
                  incrementHandler({ name: "dayID", maxValue: 7 });
                }}>
                  <ArrowTop />
                </ArrowButton>
                <ArrowButton onClick={() => {
                  decrementHandler({ name: "dayID", minValue: 1 });
                }}>
                  <ArrowDown />
                </ArrowButton>
              </InputWrapper>
            </WrapperButtons>
          )}

          {formik.values?.isRecurring && formik.values?.recurringType === 2 && (
            <WrapperButtons>
              <SwitchTabs
                options={recurringTypes}
                value={formik.values?.recurringType}
                onChange={(tab) => formik.setFieldValue("recurringType", tab?.value)}
                className="flex-shrink-1"
              />
              <InputWrapper>
                <Input
                  type="number"
                  value={formik.values?.dayInMonth}
                  onChange={(e) => {
                    handleInputChange({ event: e, name: "dayInMonth", minValue: 1 });
                  }}
                  min="1"
                  max="28"
                />
                <ArrowButton onClick={() => {
                  incrementHandler({ name: "dayInMonth", maxValue: 28 });
                }}>
                  <ArrowTop />
                </ArrowButton>
                <ArrowButton onClick={() => {
                  decrementHandler({ name: "dayInMonth", minValue: 1 });
                }}>
                  <ArrowDown />
                </ArrowButton>
              </InputWrapper>
            </WrapperButtons>
          )}
        </div>
      </animated.div>
      <animated.div style={collapseLimitStyles}>
        {enableLimitTo && (
          <div className="" >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <LabelField
                  title={"Limit to"}
                  style={{
                    fontSize: "12px",
                  }}
                  mandatory={formik.values?.isLimit}
                />
                <InfoTooltip text="Restricts this automation to accounts/contacts whose age is equal to, above, or below the number you set." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
              </div>
              <Switch
                inputProps={{ 'aria-label': 'primary checkbox' }}
                checked={formik.values?.isLimit}
                onChange={(event) => {
                  const { checked } = event.target;
                  formik.setFieldValue("isLimit", checked);
                }}
              />
            </div>
            {formik.values?.isLimit && (
              <WrapperButtons>
                <InputWrapper>
                  <Input
                    type="number"
                    value={formik.values?.age}
                    onChange={(e) => {
                      handleInputChange({ event: e, name: "age", minValue: 1, maxValue: 120 });
                    }}
                    min="1"
                  />
                  <ArrowButton onClick={() => {
                    incrementHandler({ name: "age", maxValue: 120 });
                  }}>
                    <ArrowTop />
                  </ArrowButton>
                  <ArrowButton onClick={() => {
                    decrementHandler({ name: "age", minValue: 1 });
                  }}>
                    <ArrowDown />
                  </ArrowButton>
                </InputWrapper>
                <SwitchTabs
                  options={limitTypes}
                  value={formik.values?.limit}
                  onChange={(tab) => formik.setFieldValue("limit", tab?.value)}
                  className="flex-shrink-1"
                />
              </WrapperButtons>

            )}
          </div>
        )}
      </animated.div>
    </>
  )
}

export default CreateTriggerTabs